import React from 'react';
import { Route } from 'react-router-dom';
import loadable from '@loadable/component';
import { Loader } from '../../../../common/components';

const ListSprintPage = loadable(() => import('./ListSprintPage'), {
  fallback: <Loader />
});
const AddSprintPage = loadable(() => import('./AddSprintPage'), {
  fallback: <Loader />
});
const EditSprintPage = loadable(() => import('./EditSprintPage'), {
  fallback: <Loader />
});

const SprintRoutes = ({ t, setTabLoading , alert }) => {
  return [
    <Route
      key={'sprint_view'}
      exact
      path="/view/:projectId/sprint"
      element={<ListSprintPage t={t} setTabLoading={setTabLoading} alert={alert} />}
    />,
    <Route
      key={'sprint_add'}
      exact
      path="/view/:projectId/sprint/add"
      element={<AddSprintPage t={t} setTabLoading={setTabLoading} alert={alert} />}
    />,
    <Route
      key={'sprint_edit'}
      exact
      path="/view/:projectId/sprint/:projectSprintId/edit"
      element={<EditSprintPage t={t} setTabLoading={setTabLoading} alert={alert} />}
    />
  ];
};
SprintRoutes.propTypes = {};
export default SprintRoutes;
